export default __webpack_public_path__ + "static/media/taipei.a1d9d105.png";